import { Component, ChangeDetectorRef, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SidenavService } from "../sidenav.service";
import { MatSidenav } from "@angular/material/sidenav";
import { MatDialog } from "@angular/material/dialog";
import { AngularAppLogger } from "../angular-app-logger";
import { AppStateService } from "../shared/service/app.state.service";
import { AppConfig } from "../shared/constants/app.config";
import { OidcService } from "./oidc/oidc.service";
import { ConfirmationDialogComponent } from "../confirm.dialog/confirmation.dialog.component";
import { AuditEventService } from '../services/audit-event-service';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  @ViewChild("sidenav", { static: true }) public sidenav: MatSidenav;
  appLabel: string | undefined = undefined;
  showBackButton: boolean = false;
  versionInfo: string = "";
  isAuthenticated = false;


  constructor(
    readonly ref: ChangeDetectorRef,
    readonly router: Router,
    readonly sidenavService: SidenavService,
    readonly appLogger: AngularAppLogger,
    readonly route: ActivatedRoute,
    readonly appState: AppStateService,
    readonly oidcService: OidcService,
    readonly dialog: MatDialog,
    readonly auditEventService: AuditEventService
  ) { }

  ngOnInit() {
    // Set up subscriptions
    this.appState.appLabel$.subscribe(label => {
      this.appLabel = label;
      this.versionInfo = this.appLabel?.includes("NMDP") ? AppConfig.MS_APP_VERSION : AppConfig.CRA_APP_VERSION;
      this.ref.detectChanges();
    });
    this.appState.backButton$.subscribe(isVisible => {
      this.showBackButton = isVisible;
      this.ref.detectChanges();
    });
    this.oidcService.isAuthenticated$.subscribe({
      next: (isAuth) => {
        this.isAuthenticated = isAuth;
        this.ref.detectChanges();
      },
      error: (err) => {
        console.warn('Authentication status check error (ignoring):', err.message);
      }
    });
    this.sidenavService.setSidenav(this.sidenav);
  }

  logout() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '490px',
      panelClass: "custom-dialog-container",
      disableClose: false,
      data: {
        confirmMessage: 'Are you sure? Logout will remove the previously accessed Patient data.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auditEventService.logout();
        this.oidcService.logout();
      }
    });
  }

  handleError(error: Response) {
    const text = `ERROR in call to CIBMTR Server.  Status: ${error.status}.  Text: ${error.statusText}`;
    this.appLogger.logError(error, {context: "Cibmtr fhir access issue"});
    this.appLogger.showGlobalAlert(text, {context: "Cibmtr fhir access issue"});
  }

  //Go back to landing page
  goBack() {
    this.appLabel = undefined;
    this.router.navigateByUrl('/landing', {
      state: {
        oktaToken: history.state.oktaToken,
        decoded: history.state.decoded,
        selectedOrg: history.state.selectedOrg
      }
    });
  }
}
